const rawBase = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export const API_ORIGIN = rawBase.replace(/\/+$/, '');

export function apiUrl(path = '') {
  if (!path) {
    return API_ORIGIN;
  }
  return `${API_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}
